import {
  pkcs8B64FromSeed,
  rawFromSpkiB64,
  seedFromPkcs8B64,
  spkiB64FromRaw,
  b64,
  unb64,
} from "../crypto/index.js";

/** Compact recovery: d1 + base64(pub32||seed32). ~90 chars → QR v5. */
export function encodeRecovery(publicKeyB64: string, privateKeyB64: string): string {
  const body = new Uint8Array(64);
  body.set(rawFromSpkiB64(publicKeyB64), 0);
  body.set(seedFromPkcs8B64(privateKeyB64), 32);
  return `d1${b64(body)}`;
}

export function parseRecovery(raw: string): { publicKeyB64: string; privateKeyB64: string } {
  const s = raw.trim().replace(/\s+/g, "");
  if (!s.startsWith("d1") || s.length < 10) throw new Error("bad key");
  const body = unb64(s.slice(2));
  if (body.length !== 64) throw new Error("bad key");
  return {
    publicKeyB64: spkiB64FromRaw(body.subarray(0, 32)),
    privateKeyB64: pkcs8B64FromSeed(body.subarray(32)),
  };
}
